import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutPreview from "./components/AboutPreview";
import ServicesPreview from "./components/ServicesPreview";
import WhoWeWorkWith from "./components/WhoWeWorkWith";
import NewsPreview from "./components/NewsPreview";
import ContactSection from "./components/ContactSection";

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <HeroSection />
      <AboutPreview />
      <ServicesPreview />
      <WhoWeWorkWith />
      <NewsPreview />
      <ContactSection />
      <Footer />
    </div>
  );
}
